/* @ngInject */
export default class OrganisationController {

    constructor($scope, $ngRedux) {
        console.log('ORG CONTROLLER');
    }
}